import { initGoogleTagManagerTracking as baseInitGoogleTagManagerTracking } from './platform/initGoogleTagManagerTracking'

export function initGoogleTagManagerTracking() {
  baseInitGoogleTagManagerTracking()
}
